import React, { useState } from 'react';
import {useLoginBackgroundStyle} from '../utilities/loginBackground';
import { Link, useSearchParams } from 'react-router-dom';
import {useBrandLogo} from '../utilities/genreIcons';
import './LoginForm.css';

// Landing page for the link in the "account scheduled for deletion" email
// (AccountDeletionService.cancellationUrl). The restore waits for a click rather than firing
// on load: mail scanners open links on their own, and one restoring an account its owner
// meant to delete would be worse than an extra click.
const CancelDeletion = () => {
    const loginBgStyle = useLoginBackgroundStyle();
    const ddLogo = useBrandLogo();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [status, setStatus] = useState(token ? 'idle' : 'error'); // idle | loading | success | error
    const [message, setMessage] = useState(token ? '' : 'No cancellation token found. Please use the link from your email.');

    function restore() {
        setStatus('loading');
        fetch(`${process.env.REACT_APP_API_PROXY}/account/cancel-deletion?token=${encodeURIComponent(token)}`, { method: 'POST' })
            .then(async res => {
                const data = await res.json().catch(() => ({}));
                if (res.ok) {
                    setStatus('success');
                    setMessage(data.message || 'Your account is active again.');
                } else {
                    setStatus('error');
                    setMessage(data.message || 'That cancellation link is no longer valid.');
                }
            })
            .catch(() => {
                setStatus('error');
                setMessage('Could not reach the server. Please try again later.');
            });
    }

    return (
        <div className="login" style={loginBgStyle}>
            <div className="wrapper" style={{ textAlign: 'center' }}>
                <img src={ddLogo} alt="DD_Logo" className="brand-logo brand-logo--lg" />
                {(status === 'idle' || status === 'loading') && (
                    <>
                        <h2 style={{ margin: '20px 0 10px', fontSize: '22px' }}>Keep your account?</h2>
                        <p style={{ fontSize: '14px', marginBottom: '24px', lineHeight: '1.6' }}>
                            Your account is scheduled for deletion. Restore it to cancel the deletion and sign in again.
                        </p>
                        <button type="button" onClick={restore} disabled={status === 'loading'}>
                            {status === 'loading' ? 'Restoring…' : 'Restore my account'}
                        </button>
                    </>
                )}
                {status === 'success' && (
                    <>
                        <h2 style={{ margin: '20px 0 10px', fontSize: '22px', color: 'var(--lm-tx-6fcf97)' }}>Account Restored</h2>
                        <p style={{ fontSize: '14px', marginBottom: '24px', lineHeight: '1.6' }}>{message}</p>
                        <div className="register-link">
                            <p><Link to="/">Log in to DropWyrm</Link></p>
                        </div>
                    </>
                )}
                {status === 'error' && (
                    <>
                        <h2 style={{ margin: '20px 0 10px', fontSize: '22px', color: '#eb5757' }}>Couldn't Restore Account</h2>
                        <p style={{ fontSize: '14px', marginBottom: '24px', lineHeight: '1.6' }}>{message}</p>
                        <div className="register-link">
                            <p>Need help? Email <a href="mailto:support@dropwyrm.com">support@dropwyrm.com</a></p>
                        </div>
                    </>
                )}
            </div>
            <div className="copyright-footer">
                &copy; {new Date().getFullYear()} Virtual Realms Studios, LLC. All rights reserved.
            </div>
        </div>
    );
};

export default CancelDeletion;
